export default __webpack_public_path__ + "static/media/skyship13.66657274.webp";